export default __webpack_public_path__ + "static/from-idea-to-app-6538da2092e62b673e606fa8e2793e8d.svg";